<template>
    <div id="side_menu" class="side-menu flex-lg-column ms-lg-0">
        <div class="navbar-brand-box">
            <a href="#" class="logo logo-dark">
                <span class="logo-sm">
                    <img :src="logoIconDark" alt="" height="30">
                </span>
            </a>

            <a href="#" class="logo logo-light">
                <span class="logo-sm">
                    <img :src="logoIconLight" alt="" height="30">
                </span>
            </a>
        </div>

        <div class="flex-lg-column my-auto nav-scroll-area">
            
            <ul class="nav nav-pills side-menu-nav justify-content-center resp-alinhar-menu" id="left_slide_op"
                role="tablist">

                <li class="nav-item cursor-pointer d-none" v-tooltip="{ content: 'Chat Agentes de IA', placement: 'right' }">
                    <a class="nav-link" href="#" @click.prevent="uiStore.openAiChatModal()">
                        <img src="/img/chat-gpt.png" alt="AI" class="rounded-circle avatar-xs" style="object-fit: cover;">
                    </a>
                </li>

                <li class="nav-item d-none d-lg-block w-100">
                    <ButtonNavBarUser
                        icon="ri-home-5-line"
                        tooltipText="Início"
                        :active="activeTab === 'Home'"
                        @click="setActive('Home')"
                    />
                </li>

                <!-- Grupo 1 (modos de visualização): botões fixos, sem gaveta. O
                     wrapper .nav-group existe só para lê-los como um conjunto —
                     sem ele os ícones ficam soltos no meio da coluna.
                     Somente desktop (>=992px): no mobile o bloco d-lg-none
                     abaixo permanece intocado. -->
                <li class="nav-item nav-group d-none d-lg-block">
                    <ul class="nav-group-inner">
                        <div class="position-relative">
                            <ButtonNavBarUser
                                icon="ri-message-3-line"
                                tooltipText="Modo Lista"
                                :active="activeTab === 'Lista'"
                                @click="setActive('Lista')"
                            />
                            <span v-if="listaLabel" class="nav-badge-counter bg-danger text-white">
                                {{ listaLabel }}
                            </span>
                        </div>

                        <ButtonNavBarUser
                            icon="ri-menu-2-line"
                            tooltipText="Modo Kanban"
                            :active="activeTab === 'Kanban'"
                            @click="setActive('Kanban')"
                        />

                        <ButtonNavBarUser
                            v-permission="'conta.visualizar_radar'"
                            icon="ri-radar-line"
                            tooltipText="Radar de Atendimentos"
                            :active="activeTab === 'Radar'"
                            @click="setActive('Radar')"
                        />

                        <div class="position-relative">
                            <ButtonNavBarUser icon="ri-user-community-fill" tooltipText="Chat da Equipe"
                                :active="activeTab === 'ChatEquipe'" @click="setActive('ChatEquipe')" />
                            <span v-if="internalChatStore.hasUnreadMessages"
                                class="nav-badge-counter bg-danger text-white">
                                {{ chatEquipeLabel }}
                            </span>
                        </div>
                    </ul>
                </li>

                <!-- Grupo 2 (IA): uma entrada única. O clique decide o destino
                     (conversas do agente x vitrine) em `openIaEntryPoint`. -->
                <ButtonNavBarUser
                    v-if="mostrarBotaoIa"
                    class="d-none d-lg-block"
                    icon="ri-robot-2-line"
                    tooltipText="Agentes de IA"
                    :active="activeTab === 'AtendimentosIa'"
                    @click="openIaEntryPoint()"
                    badgeType="AI"
                    :badgeCount="aiChatCount"
                />

                <!-- Bloco original: intocado, visível apenas no mobile (<992px) -->
                <ul class="nav nav-pills side-menu-nav justify-content-center pt-1 pb-1 mobile-reset-ul d-lg-none"
                    role="tablist"
                    style="background-color: var(--bs-light); border-radius: 2rem; margin: 0px 11px !important; box-shadow: var(--bs-box-shadow);">


                    <div class="position-relative order-mob-1">
                        <ButtonNavBarUser
                            icon="ri-message-3-line"
                            tooltipText="Modo Lista"
                            :active="activeTab === 'Lista'"
                            @click="setActive('Lista')"
                        />
                        <span v-if="listaLabel" class="nav-badge-counter bg-danger text-white">
                            {{ listaLabel }}
                        </span>
                    </div>

                    <!-- Kanban e Radar ficam fora da barra no mobile (decisão de
                         produto). As entradas de desktop estão no grupo fixo
                         acima (.nav-group, d-none d-lg-block). -->

                    <div class="position-relative order-mob-2">
                        <ButtonNavBarUser icon="ri-user-community-fill" tooltipText="Chat da Equipe"
                            :active="activeTab === 'ChatEquipe'" @click="setActive('ChatEquipe')" />
                        <span v-if="internalChatStore.hasUnreadMessages"
                            class="nav-badge-counter bg-danger text-white">
                            {{ chatEquipeLabel }}
                        </span>
                    </div>
                </ul>

                <ButtonNavBarUser
                    v-permission="'conta.visualizar_relatorios'"
                    class="order-mob-6"
                    icon="ri-pie-chart-line"
                    tooltipText="Dashboard"
                    :active="activeTab === 'Dashboard'"
                    @click="setActive('Dashboard')"
                />

                
                <li v-permission="'conta.visualizar_contatos'" class="nav-item d-none d-lg-block">
                    <ButtonNavBarUser 
                        icon="ri-contacts-line" 
                        tooltipText="Contatos" 
                        :active="activeTab === 'Contatos'"
                        @click="uiStore.openContactsModal()"
                    />
                </li>

                <!-- Espelho mobile do botão único de IA: mesmo handler do desktop,
                     para os dois destinos não divergirem. -->
                <li v-if="mostrarBotaoIa" class="nav-item order-mob-3 d-lg-none">
                    <ButtonNavBarUser
                        icon="ri-robot-2-line"
                        tooltipText="Agentes de IA"
                        :active="activeTab === 'AtendimentosIa'"
                        @click="openIaEntryPoint()"
                        badgeType="AI"
                        :badgeCount="aiChatCount"
                    />
                </li>

                <li class="nav-item d-lg-none order-mob-4 home-mob">
                    <ButtonNavBarUser 
                        icon="ri-home-5-line" 
                        tooltipText="Início" 
                        :active="activeTab === 'Home'"
                        @click="setActive('Home')"
                    />
                </li>
                
                <DropdownField 
                    :distance="14" 
                    placement="right-start" 
                    class="cursor-pointer d-none d-lg-block"
                    :auto-hide="true"
                >
                    <div class="position-relative">
                        <!-- O total exato vive no tooltip do sino: a badge é `pointer-events: none`
                             (o clique precisa atravessar para o gatilho do dropdown) e por isso não
                             pode carregar tooltip própria. -->
                        <ButtonNavBarUser
                            icon="ri-notification-line"
                            :tooltipText="notificationStore.unreadCount > 0 ? `Notificações (${notificationStore.unreadCount})` : 'Notificações'"
                            :active="activeTab === 'Notificacoes'"
                        />
                        <span v-if="notificationStore.unreadCount > 0"
                            class="nav-badge-counter bg-danger text-white shadow-sm">
                            {{ notificacoesLabel }}
                        </span>
                    </div>

                    <template #popper>
                        <div class="notification-dropdown">
                            
                            <div class="dropdown-header-custom d-flex justify-content-between align-items-center z-2 sticky-top">
                                <h6 class="m-0 fw-bold font-size-16">Notificações</h6>
                                <button 
                                    v-if="notificationStore.unreadCount > 0"
                                    @click="notificationStore.markAllAsRead()"
                                    class="btn btn-link text-primary p-0 text-decoration-none font-size-12 fw-semibold btn-mark-read"
                                >
                                    Marcar como lidas
                                </button>
                            </div>

                            <div class="notification-body custom-scrollbar">
                                
                                <div v-if="notificationStore.isLoading" class="p-5 text-center text-muted d-flex flex-column align-items-center gap-2">
                                    <i class="ri-loader-4-line ri-spin font-size-24 text-primary"></i> 
                                    <span class="font-size-13">Buscando atualizações...</span>
                                </div>
                                
                                <div v-else-if="notificationStore.notifications.length === 0" class="p-5 text-center text-muted d-flex flex-column align-items-center gap-3 empty-state">
                                    <div class="icon-empty-state rounded-circle d-flex align-items-center justify-content-center" style="width: 64px; height: 64px;">
                                        <i class="ri-notification-off-line font-size-24 text-muted"></i>
                                    </div>
                                    <span class="font-size-14 fw-medium">Tudo tranquilo por aqui!</span>
                                </div>

                                <div v-else
                                    v-for="notif in notificationStore.notificationsWithTimeAgo"
                                    :key="notif.id"
                                    class="notification-item cursor-pointer d-flex gap-3 position-relative"
                                    :class="!notif.lida ? 'is-unread' : ''"
                                    v-close-popper
                                    @click="notificationStore.markAsRead(notif.id); notificationStore.handleClickNotificacao(notif)"
                                >
                                    <div v-if="!notif.lida" class="unread-indicator"></div>

                                    <div class="flex-shrink-0 mt-1">
                                        <div class="notif-icon-wrapper rounded-circle d-flex align-items-center justify-content-center" :class="`icon-${notif.tipo}`">
                                            <i v-if="notif.tipo === 'ATENDIMENTO_TRANSFERIDO'" class="ri-share-forward-line"></i>
                                            <i v-else-if="notif.tipo === 'ATENDIMENTO_FINALIZADO'" class="ri-checkbox-circle-line"></i>
                                            <i v-else-if="notif.tipo === 'SINCRONIZACAO_CONTATOS_CONCLUIDA'" class="ri-refresh-line"></i>
                                            <i v-else-if="notif.tipo === 'IMPORTACAO_CONTATOS_CONCLUIDA'" class="ri-contacts-book-upload-line"></i>
                                            <i v-else-if="notif.tipo === 'EXPORTACAO_CONVERSAS_CONCLUIDA'" class="ri-download-cloud-2-line"></i>
                                            <i v-else-if="notif.tipo === 'EXPORTACAO_CONVERSAS_ERRO'" class="ri-error-warning-line"></i>
                                            <i v-else class="ri-notification-3-line"></i>
                                        </div>
                                    </div>
                                    
                                    <div class="flex-grow-1 overflow-hidden">
                                        <div class="d-flex justify-content-between align-items-start mb-1 gap-2">
                                            <h6 class="m-0 font-size-14 text-truncate notif-title" :class="!notif.lida ? 'fw-bold' : 'fw-semibold'">
                                                {{ notif.titulo }}
                                            </h6>
                                            <span class="font-size-11 text-muted flex-shrink-0 d-flex align-items-center gap-1 mt-1">
                                                <i class="ri-time-line"></i> {{ notif.timeAgo }}
                                            </span>
                                        </div>
                                        <div
                                            class="font-size-13 text-muted lh-sm notif-message"
                                            v-tooltip="notif.mensagem && notif.mensagem.length > 200 ? { content: notif.mensagem, placement: 'right' } : false"
                                        >
                                            {{ notif.mensagem }}
                                        </div>
                                    </div>
                                </div>

                            </div>

                            <div class="dropdown-footer-custom z-2 sticky-bottom">
                                <button class="btn btn-footer w-100 py-2 d-flex align-items-center justify-content-center gap-2 fw-semibold font-size-13 transition-all" v-close-popper @click="uiStore.openAllNotificationsModal()">
                                    Ver todas as notificações <i class="ri-arrow-right-line transition-transform"></i>
                                </button>
                            </div>

                        </div>
                    </template>
                </DropdownField>

                <!-- <ButtonNavBarUser 
                    class="d-lg-none"
                    icon="ri-settings-3-line" 
                    tooltipText="Gerenciar Inbox" 
                    @click="uiStore.openInboxModal()"
                />

                <ButtonNavBarUser 
                    class="d-lg-none"
                    :icon="(uiStore.theme == 'light') ? 'ri-moon-line' : 'ri-sun-line'" 
                    tooltipText="Alterar modo" 
                    @click="uiStore.changeTheme()"
                /> -->

                <li class="nav-item cursor-pointer d-lg-none order-mob-7">
                    <DropdownField 
                        ref="userDropdownRefMobile"
                        :distance="14" 
                        placement="top-end" 
                        class="cursor-pointer"
                        :auto-hide="true"
                    >
                        <div class="nav-link m-0 p-0 d-flex align-items-center justify-content-center" style="width: 48px; height: 48px;">
                            <AvatarField 
                                :foto="authStoreUser.user?.foto" 
                                class="profile-user shadow-sm" 
                            />
                        </div>
                        
                        <template #popper>
                            <div class="user-dropdown custom-scrollbar">
                                
                                <div class="p-3 bg-light-subtle border-bottom d-flex align-items-center gap-3">
                                    <AvatarField :foto="authStoreUser.user?.foto" class="flex-shrink-0" style="pointer-events: all" @click="uiStore.openUserProfileModal()"/>
                                    <div class="flex-grow-1 overflow-hidden">
                                        <div class="fw-bold text-dark font-size-14 text-truncate">
                                            {{ authStoreUser.user?.nome || 'Usuário' }}
                                        </div>
                                    </div>
                                    <DropdownField :distance="14" placement="top-start" :auto-hide="true">
                                        <button class="btn btn-sm btn-icon rounded-circle bg-white border shadow-sm" title="Alternar Conta">
                                            <i class="ri-loop-left-line"></i>
                                        </button>
                                        <template #popper>
                                            <div class="user-dropdown p-2" style="min-width: 220px">
                                                <div class="font-size-11 text-uppercase text-muted fw-bold px-2 mb-2">Alternar Conta</div>
                                                <div class="list-group list-group-flush">
                                                    <button 
                                                        v-for="conta in authStoreUser.contasFull" 
                                                        :key="conta.id"
                                                        class="dropdown-item py-2 d-flex align-items-center gap-2 border-0 px-2"
                                                        :class="{ 'active': authStoreUser.currentConta?.id === conta.id }"
                                                        @click="authStoreUser.selectConta(String(conta.id))"
                                                        v-close-popper
                                                    >
                                                        <i class="ri-links-line"></i>
                                                        <span class="text-truncate flex-grow-1">{{ conta.nome }}</span>
                                                        <i v-if="authStoreUser.currentConta?.id === conta.id" class="ri-check-line text-success ms-auto"></i>
                                                    </button>
                                                </div>
                                            </div>
                                        </template>
                                    </DropdownField>
                                </div>
                                
                                <div class="p-2 border-bottom">
                                    <!-- Ação de destaque, no topo do bloco de ações diretas.
                                         Como irmã dos cabeçalhos de accordion ela SUMIA: mesma tipografia,
                                         mesmo peso, só sem a seta — lia como um grupo quebrado, não como a
                                         configuração mais importante do menu. Aqui ela sai da hierarquia de
                                         grupos e ganha corpo próprio. Mesmo gabarito do `.wa-connect-item`
                                         (item de ação em destaque já existente no arquivo), trocando o verde
                                         do WhatsApp pela cor da marca. A segunda linha existe por descoberta:
                                         "Configurar Agente" sozinho não diz que se trata do atendente de IA. -->
                                    <button v-if="podeConfigurarAgenteIa" class="agente-ia-item w-100 mb-2" v-close-popper @click="openConfigurarAgenteIa()">
                                        <span class="agente-ia-icone"><i class="ri-robot-2-fill"></i></span>
                                        <span class="agente-ia-texto">
                                            <span class="agente-ia-titulo">Configurar Agente</span>
                                            <span class="agente-ia-sub">Seu atendente de IA</span>
                                        </span>
                                        <i class="ri-arrow-right-s-line agente-ia-seta"></i>
                                    </button>
                                    <!-- Espelho do menu desktop: mesma posição (logo abaixo da conta)
                                         e mesmo comportamento de manter o menu aberto. -->
                                    <button class="dropdown-item py-2 rounded text-secondary px-2" @click="uiStore.changeTheme()">
                                        <i :class="(uiStore.theme == 'light') ? 'ri-moon-line' : 'ri-sun-line'" class="me-2 align-middle"></i>
                                        Alterar Modo
                                        <span class="float-end font-size-12 text-muted">{{ (uiStore.theme == 'light') ? 'Claro' : 'Escuro' }}</span>
                                    </button>
                                    <button class="dropdown-item py-2 rounded text-secondary px-2 mt-1" v-close-popper @click="searchProtocol()">
                                        <i class="ri-search-line me-2 align-middle"></i> Pesquisar Protocolo
                                    </button>
                                    <button v-if="false" class="wa-connect-item w-100 mt-1" v-close-popper @click="uiStore.openWhatsappSetupModal()">
                                        <i class="ri-whatsapp-line me-2 align-middle"></i> Conectar WhatsApp
                                        <i class="ri-arrow-right-up-line float-end"></i>
                                    </button>
                                </div>

                                <div class="accordion accordion-flush" id="userDropdownAccordionMobile">
                                    
                                    <div class="accordion-item border-0">
                                        <h2 class="accordion-header">
                                            <button class="accordion-button collapsed py-2 px-3 font-size-13 text-muted fw-semibold" type="button" data-bs-toggle="collapse" data-bs-target="#collapseProfileMob">
                                                Meu Perfil
                                            </button>
                                        </h2>
                                        <div id="collapseProfileMob" class="accordion-collapse collapse" data-bs-parent="#userDropdownAccordionMobile">
                                            <div class="accordion-body p-1">
                                                <a href="#" class="dropdown-item rounded py-2 ps-4 font-size-13 text-muted px-3" v-close-popper @click.prevent="uiStore.openUserProfileModal()">
                                                    Configurar Perfil <i class="ri-user-line float-end"></i>
                                                </a>
                                                <a href="#" class="dropdown-item rounded py-2 ps-4 font-size-13 text-muted px-3" v-close-popper @click.prevent="uiStore.openTemplatesModal()">
                                                    Meus Templates <i class="ri-file-list-3-line float-end"></i>
                                                </a>
                                                <a href="#" class="dropdown-item rounded py-2 ps-4 font-size-13 text-muted px-3" v-close-popper @click.prevent="openAction('Análise de Atendimentos')">
                                                    Análise de Atendimentos <i class="ri-pie-chart-line float-end"></i>
                                                </a>
                                            </div>
                                        </div>
                                    </div>

                                    <!-- F-26: mesma permissão do menu desktop. -->
                                    <div v-permission="'conta.visualizar_relatorios'" class="accordion-item border-0">
                                        <h2 class="accordion-header">
                                            <button class="accordion-button collapsed py-2 px-3 font-size-13 text-muted fw-semibold" type="button" data-bs-toggle="collapse" data-bs-target="#collapseReportsMob">
                                                Relatórios
                                            </button>
                                        </h2>
                                        <div id="collapseReportsMob" class="accordion-collapse collapse" data-bs-parent="#userDropdownAccordionMobile">
                                            <div class="accordion-body p-1">
                                                <a href="#" class="dropdown-item rounded py-2 ps-4 font-size-13 text-muted px-3" 
                                                v-close-popper 
                                                @click.prevent="uiStore.openReportsModal('general')">
                                                    Relatório Geral <i class="ri-file-list-3-line float-end"></i>
                                                </a>

                                                <a v-if="temIntegracaoIa" v-permission="'conta.visualizar_relatorios'" href="#" class="dropdown-item rounded py-2 ps-4 font-size-13 text-muted px-3"
                                                v-close-popper
                                                @click.prevent="uiStore.openReportsModal('agente-ia')">
                                                    Relatório de IA <i class="ri-robot-2-line float-end"></i>
                                                </a>

                                                <a href="#" class="dropdown-item rounded py-2 ps-4 font-size-13 text-muted px-3" 
                                                v-close-popper 
                                                @click.prevent="uiStore.openReportsModal('rotation')">
                                                    Relatório de Rodízio <i class="ri-recycle-line float-end"></i>
                                                </a>

                                                <a href="#" class="dropdown-item rounded py-2 ps-4 font-size-13 text-muted px-3"
                                                v-close-popper
                                                @click.prevent="uiStore.openReportsModal('contacts')">
                                                    Relatório de Contatos <i class="ri-group-2-line float-end"></i>
                                                </a>

                                                <a v-if="authStoreUser.currentAccountHasComercialInbox" href="#" class="dropdown-item rounded py-2 ps-4 font-size-13 text-muted px-3"
                                                v-close-popper
                                                @click.prevent="uiStore.openReportsModal('conversoes')">
                                                    Relatório de Conversões <i class="ri-line-chart-line float-end"></i>
                                                </a>

                                                <a v-permission="'conta.visualizar_relatorio_chat_interno'" href="#" class="dropdown-item rounded py-2 ps-4 font-size-13 text-muted px-3"
                                                v-close-popper
                                                @click.prevent="uiStore.openReportsModal('chat-interno')">
                                                    Relatório de Chat Interno <i class="ri-team-line float-end"></i>
                                                </a>

                                            </div>
                                        </div>
                                    </div>

                                    <div class="accordion-item border-0">
                                        <h2 class="accordion-header">
                                            <button class="accordion-button collapsed py-2 px-3 font-size-13 text-muted fw-semibold" type="button" data-bs-toggle="collapse" data-bs-target="#collapseAutomationsMob">
                                                Automações
                                            </button>
                                        </h2>
                                        <div id="collapseAutomationsMob" class="accordion-collapse collapse" data-bs-parent="#userDropdownAccordionMobile">
                                            <div class="accordion-body p-1">
                                                <!-- "Ações em Lote" não entra aqui: este menu é o `d-lg-none` (mobile),
                                                     e a funcionalidade é exclusiva do desktop. Item fica só no menu `d-none d-lg-block`. -->
                                                <a href="#" class="dropdown-item rounded py-2 ps-4 font-size-13 text-muted px-3" v-close-popper @click.prevent="uiStore.openBotListModal()">
                                                    BOT's <i class="ri-robot-line float-end"></i>
                                                </a>
                                                <a href="#" class="dropdown-item rounded py-2 ps-4 font-size-13 text-muted px-3" v-close-popper @click.prevent="uiStore.openCampanhasModal()">
                                                    Campanhas <i class="ri-send-plane-fill float-end"></i>
                                                </a>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="accordion-item border-0">
                                        <h2 class="accordion-header">
                                            <button class="accordion-button collapsed py-2 px-3 font-size-13 text-muted fw-semibold" type="button" data-bs-toggle="collapse" data-bs-target="#collapseSystemMob">
                                                Sistema
                                            </button>
                                        </h2>
                                        <div id="collapseSystemMob" class="accordion-collapse collapse" data-bs-parent="#userDropdownAccordionMobile">
                                            <div class="accordion-body p-1">
                                                <a href="#" class="dropdown-item rounded py-2 ps-4 font-size-13 text-muted px-3" v-close-popper @click.prevent="uiStore.openAgentsModal()">
                                                    Atendentes <i class="ri-group-line float-end"></i>
                                                </a>
                                                <a href="#" class="dropdown-item rounded py-2 ps-4 font-size-13 text-muted px-3" v-close-popper @click="openSchedules">
                                                    Agendamentos <i class="ri-calendar-2-line float-end"></i>
                                                </a>
                                                <a href="#" class="dropdown-item rounded py-2 ps-4 font-size-13 text-muted px-3" v-close-popper @click.prevent="uiStore.openCampanhasModal()">
                                                    Campanhas <i class="ri-send-plane-2-line float-end"></i>
                                                </a>
                                                <a
                                                    :href="urlDocumentacaoApi"
                                                    rel="noopener"
                                                    target="_blank"
                                                    class="dropdown-item rounded py-2 ps-4 font-size-13 text-muted px-3"
                                                    v-close-popper
                                                >
                                                    Desenvolvedor <i class="ri-code-s-slash-line float-end"></i>
                                                </a>
                                                <!-- <a href="#" class="dropdown-item rounded py-2 ps-4 font-size-13 text-muted px-3" v-close-popper @click.prevent="openAction('Status da Equipe')">
                                                    Status da Equipe <i class="ri-time-line float-end"></i>
                                                </a> -->
                                                <!-- <a href="#" class="dropdown-item rounded py-2 ps-4 font-size-13 text-muted px-3" v-close-popper @click.prevent="openAction('Assuntos')">
                                                    Assuntos <i class="ri-feedback-line float-end"></i>
                                                </a> -->
                                                <a href="#" class="dropdown-item rounded py-2 ps-4 font-size-13 text-muted px-3" v-close-popper @click.prevent="uiStore.openAddTagModal()">
                                                    Etiquetas <i class="ri-price-tag-3-fill float-end"></i>
                                                </a>
                                                <a v-permission="'conta.exportar_conversas'" href="#" class="dropdown-item rounded py-2 ps-4 font-size-13 text-muted px-3" v-close-popper @click.prevent="uiStore.openExportacoesModal()">
                                                    Exportações <i class="ri-download-cloud-2-line float-end"></i>
                                                </a>
                                                <!-- <a href="#" class="dropdown-item rounded py-2 ps-4 font-size-13 text-muted px-3" v-close-popper @click.prevent="openAction('Chat GPT')">
                                                    Chat GPT <i class="ri-openai-fill float-end"></i>
                                                </a> -->
                                                <!-- Inboxes: só desktop. Some no aparelho de toque (PWA ou navegador). -->
                                                <a v-if="!isMobileDevice" href="#" class="dropdown-item rounded py-2 ps-4 font-size-13 text-muted px-3" v-close-popper @click.prevent="uiStore.openInboxModal()">
                                                    Inboxes <i class="ri-settings-2-line float-end"></i>
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="p-2 border-top mt-1">
                                    <button class="dropdown-item rounded py-2 text-danger fw-semibold px-2" v-close-popper @click="logout()">
                                        Sair <i class="ri-logout-circle-r-line float-end"></i>
                                    </button>
                                </div>
                            </div>
                        </template>
                    </DropdownField>
                </li>

            </ul>
        </div>
        
        <div class="flex-lg-column d-none d-lg-block">
            <ul class="nav side-menu-nav justify-content-center mb-3">

                <div class="position-relative">
                    <ButtonNavBarUser
                        icon="ri-megaphone-line"
                        tooltipText="Novidades & Atualizações"
                        @click="openNovidades()"
                    />
                    <span v-if="novidadesStore.hasNew"
                        class="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger"
                        style="font-size: 0.6rem; padding: 0.2rem 0.35rem; transform: translate(-40%, -20%) !important; min-width: 8px; height: 8px; border-radius: 50% !important; padding: 0 !important;">
                    </span>
                </div>

                    <!-- Este bloco é `d-none d-lg-block`, mas um tablet em paisagem passa
                         dos 992px: sem o guard, o atalho reapareceria no aparelho de toque. -->
                    <ButtonNavBarUser
                        v-if="!isMobileDevice"
                        icon="ri-settings-3-line"
                        tooltipText="Gerenciar Inbox"
                        @click="uiStore.openInboxModal()"
                    />


                <!-- "Alterar Modo" saiu daqui: virou item do menu do perfil, logo
                     abaixo do bloco da conta. -->

                <DropdownField
                    ref="userDropdownRef" 
                    :distance="14" 
                    placement="top-start" 
                    class="cursor-pointer"
                    :auto-hide="true"
                >
                    <AvatarField :foto="authStoreUser.user?.foto" />
                    <template #popper>
                        <div class="user-dropdown custom-scrollbar">
                            
                            <div class="p-3 bg-light-subtle border-bottom d-flex align-items-center gap-3">
                                <AvatarField :foto="authStoreUser.user?.foto" class="flex-shrink-0" v-close-popper @click.prevent="uiStore.openUserProfileModal()" />
                                <div class="flex-grow-1 overflow-hidden">
                                    <div class="fw-bold text-dark font-size-14 text-truncate">
                                        {{ authStoreUser.user?.nome || 'Usuário' }}
                                    </div>
                                    <div class="text-muted font-size-12 text-truncate">
                                        {{ authStoreUser.user?.email || 'usuario@whiz.com' }}
                                    </div>
                                </div>
                                <DropdownField :distance="14" placement="right-start" :auto-hide="true">
                                    <button class="btn btn-sm btn-icon rounded-circle bg-white border shadow-sm" title="Alternar Conta">
                                        <i class="ri-loop-left-line"></i>
                                    </button>
                                    <template #popper>
                                        <div class="user-dropdown p-2" style="min-width: 220px">
                                            <div class="font-size-11 text-uppercase text-muted fw-bold px-2 mb-2">Alternar Conta</div>
                                            <div class="list-group list-group-flush">
                                                <button 
                                                    v-for="conta in authStoreUser.contasFull" 
                                                    :key="conta.id"
                                                    class="dropdown-item py-2 d-flex align-items-center gap-2 border-0 px-2"
                                                    :class="{ 'active': authStoreUser.currentConta?.id === conta.id }"
                                                    @click="authStoreUser.selectConta(String(conta.id), true)" 
                                                    v-close-popper
                                                >
                                                    <i class="ri-links-line"></i>
                                                    <span class="text-truncate flex-grow-1">{{ conta.nome }}</span>
                                                    <i v-if="authStoreUser.currentConta?.id === conta.id" class="ri-check-line text-success ms-auto"></i>
                                                </button>
                                            </div>
                                        </div>
                                    </template>
                                </DropdownField>
                            </div>

                            <div class="p-2 border-bottom">
                                <!-- Ação de destaque, no topo do bloco de ações diretas.
                                     Como irmã dos cabeçalhos de accordion ela SUMIA: mesma tipografia,
                                     mesmo peso, só sem a seta — lia como um grupo quebrado, não como a
                                     configuração mais importante do menu. Aqui ela sai da hierarquia de
                                     grupos e ganha corpo próprio. Mesmo gabarito do `.wa-connect-item`
                                     (item de ação em destaque já existente no arquivo), trocando o verde
                                     do WhatsApp pela cor da marca. A segunda linha existe por descoberta:
                                     "Configurar Agente" sozinho não diz que se trata do atendente de IA. -->
                                <button v-if="podeConfigurarAgenteIa" class="agente-ia-item w-100 mb-2" v-close-popper @click="openConfigurarAgenteIa()">
                                    <span class="agente-ia-icone"><i class="ri-robot-2-fill"></i></span>
                                    <span class="agente-ia-texto">
                                        <span class="agente-ia-titulo">Configurar Agente</span>
                                        <span class="agente-ia-sub">Seu atendente de IA</span>
                                    </span>
                                    <i class="ri-arrow-right-s-line agente-ia-seta"></i>
                                </button>
                                <!-- Sem v-close-popper: o tema troca à vista, e fechar o menu
                                     obrigaria a reabri-lo só para desfazer a escolha. -->
                                <button class="dropdown-item py-2 rounded text-secondary px-2" @click="uiStore.changeTheme()">
                                    <i :class="(uiStore.theme == 'light') ? 'ri-moon-line' : 'ri-sun-line'" class="me-2 align-middle"></i>
                                    Alterar Modo
                                    <span class="float-end font-size-12 text-muted">{{ (uiStore.theme == 'light') ? 'Claro' : 'Escuro' }}</span>
                                </button>
                                <button class="dropdown-item py-2 rounded text-secondary px-2 mt-1" v-close-popper @click="searchProtocol()">
                                    <i class="ri-search-line me-2 align-middle"></i> Pesquisar Protocolo
                                </button>
                                <button v-if="false" class="wa-connect-item w-100 mt-1" v-close-popper @click="uiStore.openWhatsappSetupModal()">
                                    <i class="ri-whatsapp-line me-2 align-middle"></i> Conectar WhatsApp
                                    <i class="ri-arrow-right-up-line float-end"></i>
                                </button>
                            </div>

                            <div class="accordion accordion-flush" id="userDropdownAccordion">
                                
                                <div class="accordion-item border-0">
                                    <h2 class="accordion-header">
                                        <button class="accordion-button collapsed py-2 px-3 font-size-13 text-muted fw-semibold" type="button" data-bs-toggle="collapse" data-bs-target="#collapseProfile">
                                            Meu Perfil
                                        </button>
                                    </h2>
                                    <div id="collapseProfile" class="accordion-collapse collapse" data-bs-parent="#userDropdownAccordion">
                                        <div class="accordion-body p-1">
                                            <a href="#" class="dropdown-item rounded py-2 ps-4 font-size-13 text-muted px-3" v-close-popper @click.prevent="uiStore.openUserProfileModal()">
                                                Configurar Perfil <i class="ri-user-line float-end"></i>
                                            </a>
                                            <a v-permission="'conta.visualizar_templates'" href="#" class="dropdown-item rounded py-2 ps-4 font-size-13 text-muted px-3" v-close-popper @click.prevent="uiStore.openTemplatesModal()">
                                                Meus Templates <i class="ri-file-list-3-line float-end"></i>
                                            </a>
                                            <a href="#" class="dropdown-item rounded py-2 ps-4 font-size-13 text-muted px-3" v-close-popper @click.prevent="openAction('Análise de Atendimentos')">
                                                Análise de Atendimentos <i class="ri-pie-chart-line float-end"></i>
                                            </a>
                                        </div>
                                    </div>
                                </div>

                                <div v-permission="'conta.visualizar_relatorios'" class="accordion-item border-0">
                                    <h2 class="accordion-header">
                                        <button class="accordion-button collapsed py-2 px-3 font-size-13 text-muted fw-semibold" type="button" data-bs-toggle="collapse" data-bs-target="#collapseReports">
                                            Relatórios
                                        </button>
                                    </h2>
                                    <div id="collapseReports" class="accordion-collapse collapse" data-bs-parent="#userDropdownAccordion">
                                        <div class="accordion-body p-1">
                                            <a href="#" class="dropdown-item rounded py-2 ps-4 font-size-13 text-muted px-3" 
                                            v-close-popper 
                                            @click.prevent="uiStore.openReportsModal('general')">
                                                Relatório Geral <i class="ri-file-list-3-line float-end"></i>
                                            </a>

                                            <a v-if="temIntegracaoIa" v-permission="'conta.visualizar_relatorios'" href="#" class="dropdown-item rounded py-2 ps-4 font-size-13 text-muted px-3"
                                            v-close-popper
                                            @click.prevent="uiStore.openReportsModal('agente-ia')">
                                                Relatório de IA <i class="ri-robot-2-line float-end"></i>
                                            </a>

                                            <a href="#" class="dropdown-item rounded py-2 ps-4 font-size-13 text-muted px-3" 
                                            v-close-popper 
                                            @click.prevent="uiStore.openReportsModal('rotation')">
                                                Relatório de Rodízio <i class="ri-recycle-line float-end"></i>
                                            </a>

                                            <a href="#" class="dropdown-item rounded py-2 ps-4 font-size-13 text-muted px-3"
                                            v-close-popper
                                            @click.prevent="uiStore.openReportsModal('contacts')">
                                                Relatório de Contatos <i class="ri-group-2-line float-end"></i>
                                            </a>

                                            <a v-if="authStoreUser.currentAccountHasComercialInbox" href="#" class="dropdown-item rounded py-2 ps-4 font-size-13 text-muted px-3"
                                            v-close-popper
                                            @click.prevent="uiStore.openReportsModal('conversoes')">
                                                Relatório de Conversões <i class="ri-line-chart-line float-end"></i>
                                            </a>

                                            <a v-permission="'conta.visualizar_relatorio_chat_interno'" href="#" class="dropdown-item rounded py-2 ps-4 font-size-13 text-muted px-3"
                                            v-close-popper
                                            @click.prevent="uiStore.openReportsModal('chat-interno')">
                                                Relatório de Chat Interno <i class="ri-team-line float-end"></i>
                                            </a>

                                        </div>
                                    </div>
                                </div>

                                <div class="accordion-item border-0">
                                    <h2 class="accordion-header">
                                        <button class="accordion-button collapsed py-2 px-3 font-size-13 text-muted fw-semibold" type="button" data-bs-toggle="collapse" data-bs-target="#collapseAutomations">
                                            Automações
                                        </button>
                                    </h2>
                                    <div id="collapseAutomations" class="accordion-collapse collapse" data-bs-parent="#userDropdownAccordion">
                                        <div class="accordion-body p-1">
                                            <a v-permission="'conta.acoes_em_lote'" href="#" class="dropdown-item rounded py-2 ps-4 font-size-13 text-muted px-3" v-close-popper @click.prevent="uiStore.openBatchActionModal()">
                                                Ações em Lote <i class="ri-flashlight-fill float-end"></i>
                                            </a>
                                            <a v-permission="'conta.visualizar_chatbots'" href="#" class="dropdown-item rounded py-2 ps-4 font-size-13 text-muted px-3" v-close-popper @click.prevent="uiStore.openBotListModal()">
                                                BOT's <i class="ri-robot-line float-end"></i>
                                            </a>
                                            <a href="#" class="dropdown-item rounded py-2 ps-4 font-size-13 text-muted px-3" v-close-popper @click.prevent="uiStore.openCampanhasModal()">
                                                Campanhas <i class="ri-send-plane-fill float-end"></i>
                                            </a>
                                        </div>
                                    </div>
                                </div>

                                <div class="accordion-item border-0">
                                    <h2 class="accordion-header">
                                        <button class="accordion-button collapsed py-2 px-3 font-size-13 text-muted fw-semibold" type="button" data-bs-toggle="collapse" data-bs-target="#collapseSystem">
                                            Sistema
                                        </button>
                                    </h2>
                                    <div id="collapseSystem" class="accordion-collapse collapse" data-bs-parent="#userDropdownAccordion">
                                        <div class="accordion-body p-1">
                                            <a v-permission="'inbox.gerenciar_atendentes'" href="#" class="dropdown-item rounded py-2 ps-4 font-size-13 text-muted px-3" v-close-popper @click.prevent="uiStore.openAgentsModal()">
                                                Atendentes <i class="ri-group-line float-end"></i>
                                            </a>
                                            <a v-permission="'inbox.ver_agendamentos'" href="#" class="dropdown-item rounded py-2 ps-4 font-size-13 text-muted px-3" v-close-popper @click="openSchedules">
                                                Agendamentos <i class="ri-calendar-2-line float-end"></i>
                                            </a>
                                            <a href="#" class="dropdown-item rounded py-2 ps-4 font-size-13 text-muted px-3" v-close-popper @click.prevent="uiStore.openCampanhasModal()">
                                                Campanhas <i class="ri-send-plane-2-line float-end"></i>
                                            </a>
                                            <a
                                                :href="urlDocumentacaoApi"
                                                rel="noopener"
                                                target="_blank"
                                                class="dropdown-item rounded py-2 ps-4 font-size-13 text-muted px-3"
                                                v-close-popper
                                            >
                                                Desenvolvedor <i class="ri-code-s-slash-line float-end"></i>
                                            </a>
                                            <!-- <a href="#" class="dropdown-item rounded py-2 ps-4 font-size-13 text-muted px-3" v-close-popper @click.prevent="openAction('Status da Equipe')">
                                                Status da Equipe <i class="ri-time-line float-end"></i>
                                            </a> -->
                                            <!-- <a href="#" class="dropdown-item rounded py-2 ps-4 font-size-13 text-muted px-3" v-close-popper @click.prevent="openAction('Assuntos')">
                                                Assuntos <i class="ri-feedback-line float-end"></i>
                                            </a> -->
                                            <a v-permission="'conta.visualizar_etiquetas'" href="#" class="dropdown-item rounded py-2 ps-4 font-size-13 text-muted px-3" v-close-popper @click.prevent="uiStore.openAddTagModal()">
                                                Etiquetas <i class="ri-price-tag-3-fill float-end"></i>
                                            </a>
                                            <a v-permission="'conta.exportar_conversas'" href="#" class="dropdown-item rounded py-2 ps-4 font-size-13 text-muted px-3" v-close-popper @click.prevent="uiStore.openExportacoesModal()">
                                                Exportações <i class="ri-download-cloud-2-line float-end"></i>
                                            </a>
                                            <!-- <a href="#" class="dropdown-item rounded py-2 ps-4 font-size-13 text-muted px-3" v-close-popper @click.prevent="openAction('Chat GPT')">
                                                Chat GPT <i class="ri-openai-fill float-end"></i>
                                            </a> -->
                                            <!-- Mesmo motivo do menu mobile: tablet em paisagem cai neste menu. -->
                                            <a v-if="!isMobileDevice" v-permission="'conta.visualizar_inboxes'" href="#" class="dropdown-item rounded py-2 ps-4 font-size-13 text-muted px-3" v-close-popper @click.prevent="uiStore.openInboxModal()">
                                                Inboxes <i class="ri-settings-2-line float-end"></i>
                                            </a>
                                        </div>
                                    </div>
                                </div>

                            </div>

                            <div class="p-2 border-top mt-1">
                                <button class="dropdown-item rounded py-2 text-danger fw-semibold px-2" v-close-popper @click="logout()">
                                    Sair <i class="ri-logout-circle-r-line float-end"></i>
                                </button>
                            </div>

                        </div>
                    </template>
                </DropdownField>
            </ul>
        </div>
    </div>
</template>
<script>
import { computed, ref, watch, onMounted } from 'vue';
import ButtonNavBarUser from './ButtonNavBarUser.vue';
import { useAuthStoreUser } from '@/stores/app/authUser';
import { useUiStore } from '@/stores/app/uiStore';
import { useChatStore } from '@/stores/app/chatStore'; 
import AvatarField from '@/components/global/AvatarField.vue';
import { toast } from 'vue3-toastify';
import { URL_DOCUMENTACAO_API_CLIENTE } from '@/utils/urlDocumentacaoApiCliente';
import { useScheduleStore } from '@/stores/app/scheduleStore';
import { useInternalChatStore } from '@/stores/app/chatInternoStore';
import { useNotificationStore } from '@/stores/app/notificationStore';
import { useNovidadesStore } from '@/stores/app/novidadesStore';
import { useCompanyLogo } from '@/composables/useCompanyLogo';
import { cHasCloneAccess } from '@/composables/useCloneAccess';
import { useDevice } from '@/composables/useDevice';
import { usePermissoesStore } from '@/stores/app/permissoesStore';
import { formatUnreadCount } from '@/utils/formatUnreadCount';
import { ehAtendimentoOcultoPorCampanha } from '@/utils/campanhaAtendimento';

export default {
    name: 'NavBarLeftUser',
    components: {
        ButtonNavBarUser,
        AvatarField,
    },
    setup() {
        const { logoLight, logoDark, logoIconLight, logoIconDark } = useCompanyLogo();
        const uiStore = useUiStore();
        const authStoreUser = useAuthStoreUser();
        const chatStore = useChatStore(); 
        const scheduleStore = useScheduleStore();
        const userDropdownRef = ref(null);
        const userDropdownRefMobile = ref(null);
        const internalChatStore = useInternalChatStore();

        const notificationStore = useNotificationStore();
        const novidadesStore = useNovidadesStore();

        // Gerenciar Inbox é exclusivo do desktop: o formulário não cabe na tela do
        // celular (a rolagem horizontal fica travada). `isMobileDevice` é por
        // capacidade do aparelho (toque, sem hover), então pega tanto o PWA
        // instalado no celular quanto o navegador do celular — e deixa passar o
        // desktop, inclusive com a janela estreita.
        const { isMobileDevice } = useDevice();

        const activeTab = computed(() => uiStore.activeTab);

        // Contadores sobrepostos aos ícones: numa coluna de 75px o número exato
        // acima de 99 só serve para a badge vazar a lateral do menu. O valor
        // cheio continua no tooltip do sino.
        const notificacoesLabel = computed(() => formatUnreadCount(notificationStore.unreadCount));
        const chatEquipeLabel = computed(() => formatUnreadCount(internalChatStore.totalUnreadCount));

        // Mesma base do contador por inbox do ListHeader: atendimento de campanha
        // ainda oculto não aparece na lista, então não entra na soma.
        const listaLabel = computed(() => {
            const total = chatStore.chatList
                .filter(c => !ehAtendimentoOcultoPorCampanha(c))
                .reduce((acc, chat) => acc + (chat.unreadCount || 0), 0);
            return formatUnreadCount(total);
        });

        const setActive = (tabName) => {
            uiStore.setActiveTab(tabName);
            if (tabName === 'ChatEquipe') {
                chatStore.setChatContext('team');
                internalChatStore.setInternalChatMode(true);
                // Clicar de novo no ícone fecha a conversa aberta, como na Lista
                internalChatStore.closeChat();
            } else {
                internalChatStore.setInternalChatMode(false);
                // Garante que o contexto fique correto quando sair da Home/Chat Interno para o Kanban, Lista ou Radar
                if (tabName === 'Kanban' || tabName === 'Lista' || tabName === 'Radar') {
                    chatStore.setChatContext('customer');
                }

                if (tabName === 'Lista' || tabName === 'AtendimentosIa') {
                    if (chatStore.chatContext !== 'customer') {
                        chatStore.setChatContext('customer');
                    }
                }

            }

            // Ao entrar em "Atendimentos com IA", desfaz a conversa selecionada para
            // voltar à tela de boas-vindas (não herda o chat aberto na Lista/Kanban).
            if (tabName === 'AtendimentosIa') {
                chatStore.closeChat();
                uiStore.closeChatModal();
            }
        };

        const openSchedules = () => {
            scheduleStore.openManager(null, null);
        };

        const openNovidades = () => {
            uiStore.openNewsModal();
        };
        onMounted(async () => {
            try {
                await chatStore.init();
                await internalChatStore.fetchChats();
                
                await notificationStore.fetchNotifications();

                const wss = authStoreUser.wsService;
                if (wss) {
                    wss.registerCallback('NOTIFICACAO.NOVA', (payload) => {
                        notificationStore.handleNovaNotificacao(payload);
                    });
                } else {
                    console.warn('[NavBar] wsService não disponível ao registrar callback de notificação');
                }

                console.log("[NavBar] Stores inicializados com sucesso");
            } catch (error) {
                console.error("[NavBar] Erro ao inicializar stores:", error);
            }
        });

        const aiChatCount = computed(() => chatStore.filteredChatsWItemType.filter(chat => chat.itemType === 'chat' && (!!chat.idChatBotIa && !chat.statusIntegracaoIa)).length);

        const { hasCloneAccess } = cHasCloneAccess(authStoreUser);

        const permissoesStore = usePermissoesStore();

        // Permissão de escopo INBOX: a entrada do menu não é de um inbox específico,
        // então basta tê-la em algum inbox da conta corrente. O mesmo recorte gateia,
        // no backend, as rotas de escrita de Agente.
        /**
         * A entrada "Relatório de IA" só existe para contas que têm IA. O critério é
         * `idInstanciaBotIa` — basta a INSTÂNCIA, um inbox com instância e sem agente já está
         * vinculado à integração. Mesmo getter que governa a aba na Central de Relatórios.
         */
        const temIntegracaoIa = computed(
            () => authStoreUser.currentAccountHasAtLeastOneInboxWithAiAgent,
        );

        const podeConfigurarAgenteIa = computed(() => {
            const idConta = authStoreUser.currentConta?.id;
            if (!idConta) return false;
            return authStoreUser.currentAccountInboxes.some(
                i => permissoesStore.temPermissao('inbox.configurar_agente_ia', idConta, i.id),
            );
        });

        /**
         * Entrada "Atendimentos com IA". Permissão de escopo INBOX, mas a
         * entrada abre a lista da conta inteira e não a de um inbox — então o
         * recorte é "tem em algum inbox", mesmo critério de
         * `podeConfigurarAgenteIa` logo acima.
         */
        const podeAcompanharAtendimentosIa = computed(() => chatStore.podeAcompanharAtendimentosDoAgente);

        /**
         * Botão único de IA no sidebar. Mesmo recorte que antes decidia a
         * existência da gaveta: quem não acompanha nem configura agente não tem
         * o que fazer com a entrada.
         */
        const mostrarBotaoIa = computed(
            () => podeAcompanharAtendimentosIa.value || podeConfigurarAgenteIa.value,
        );

        /**
         * Destino do botão de IA:
         * - conta SEM agente contratado -> vitrine de vendas (upsell);
         * - conta COM agente contratado -> tela de conversas do agente.
         *
         * O terceiro caso (tem agente na conta, mas o usuário não tem a
         * permissão de acompanhar) só chega aqui quando o botão apareceu por
         * `podeConfigurarAgenteIa`: aí a configuração está no menu do perfil,
         * e mandá-lo para uma lista que ele não pode ver seria pior que avisar.
         */
        const openIaEntryPoint = () => {
            if (!hasCloneAccess.value) {
                uiStore.openCloneUpsellModal();
                return;
            }
            if (!podeAcompanharAtendimentosIa.value) {
                toast.warning('Você não tem permissão para acompanhar os atendimentos do Agente de IA.');
                return;
            }
            setActive('AtendimentosIa');
        };

        // Entrada de configuração do Agente (hoje no menu do perfil): leva ao modal de
        // gestão (conta com acesso) ou à vitrine de vendas (conta sem acesso). Sem seletor
        // de inbox: usa o primeiro inbox com integração de Bot de IA conectada — TODO:
        // seletor quando houver múltiplos.
        const openConfigurarAgenteIa = () => {
            if (!hasCloneAccess.value) {
                uiStore.openCloneUpsellModal();
                return;
            }
            const idConta = authStoreUser.currentConta?.id;
            // Precisa da permissão NO inbox escolhido: abrir a modal num inbox sem ela
            // levaria a 403 em toda escrita, com o formulário já preenchido na tela.
            const inboxComBot = authStoreUser.currentAccountInboxes.find(
                i => !!i.idInstanciaBotIa
                    && !!idConta
                    && permissoesStore.temPermissao('inbox.configurar_agente_ia', idConta, i.id),
            );
            if (!inboxComBot) {
                toast.warning('Conecte um canal de WhatsApp primeiro para configurar o Agente de IA.');
                return;
            }
            uiStore.openAgenteIaModal(String(inboxComBot.id));
        };

        return {
            // F-55: link "Desenvolvedor" do cliente — URL FIXA (decisão do operador, 2026-11-03).
            urlDocumentacaoApi: URL_DOCUMENTACAO_API_CLIENTE,
            openConfigurarAgenteIa,
            openIaEntryPoint,
            podeConfigurarAgenteIa,
            temIntegracaoIa,
            podeAcompanharAtendimentosIa,
            mostrarBotaoIa,
            uiStore,
            authStoreUser,
            chatStore,
            internalChatStore,
            notificationStore,
            novidadesStore,
            activeTab,
            notificacoesLabel,
            chatEquipeLabel,
            listaLabel,
            setActive,
            userDropdownRef,
            userDropdownRefMobile,
            openSchedules,
            openNovidades,
            logoLight,
            logoDark,
            logoIconLight,
            logoIconDark,
            aiChatCount,
            isMobileDevice,
        };
    },
    methods: {
        showModalInbox() { this.$refs.tempButtons.showModalInbox(); },
        showModalDirect() { this.$refs.tempButtons.showModalDirect(); },
        async logout() { await this.authStoreUser.logout(); this.$router.push('/') },
        searchProtocol() { toast.info("Pesquisa de protocolo em breve!"); },
        openAction(actionName) { toast.info(`Funcionalidade "${actionName}" em desenvolvimento.`); }
    },
}
</script>

<style scoped>
/* Item "Conectar WhatsApp" em destaque no menu do usuário */
.wa-connect-item {
    display: flex;
    align-items: center;
    border: none;
    border-radius: 10px;
    padding: 10px 12px;
    font-size: 13px;
    font-weight: 600;
    text-align: left;
    color: #1faa55;
    background: #25d3661a;
    transition: background 0.15s, transform 0.1s;
}
.wa-connect-item:hover {
    background: #25d36630;
    transform: translateY(-1px);
}
.wa-connect-item .ri-whatsapp-line {
    font-size: 16px;
    line-height: 1;
}
/* Empurra a seta para a direita alinhada verticalmente (substitui o float-end). */
.wa-connect-item .ri-arrow-right-up-line {
    margin-left: auto;
    float: none;
}

/* Animação do badge */
.badge {
    animation: pulse 2s infinite;
}

/* Contador sobreposto ao ícone (sino, Chat da Equipe).
   Ancorado pela DIREITA: com `start-100`/`left` a badge crescia para fora dos
   75px da coluna a cada dígito novo e o `.nav-scroll-area` respondia com barra
   de rolagem horizontal. Com `right` fixo ela cresce para dentro, sobre o
   ícone, e a borda direita nunca passa de ~2px além do botão de 48px. */
.nav-badge-counter {
    position: absolute;
    top: 1px;
    right: calc(50% - 26px);
    z-index: 3;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 16px;
    height: 16px;
    padding: 0 5px;
    border-radius: 9999px;
    font-size: 0.625rem;
    font-weight: 700;
    line-height: 1;
    white-space: nowrap;
    font-variant-numeric: tabular-nums;
    pointer-events: none;
    color: white !important
}

/* Permite rolar a coluna de ícones com a roda do mouse quando há mais botões do que
   altura disponível, sem exibir uma barra de rolagem chamativa. */
@media (min-width: 992px) {
    .nav-scroll-area {
        flex: 1 1 auto;
        min-height: 0;
        overflow-y: auto;
        /* Sem isto o `overflow-x` computa para `auto` (regra do CSS: com um eixo
           diferente de `visible`, o outro deixa de ser `visible`) e qualquer
           elemento que vaze 1px na horizontal — como a badge antiga — vira uma
           barra de rolagem. */
        overflow-x: hidden;
        scrollbar-width: thin;
        scrollbar-color: transparent transparent;
    }
    .nav-scroll-area::-webkit-scrollbar { width: 4px; }
    .nav-scroll-area::-webkit-scrollbar-track { background: transparent; }
    .nav-scroll-area::-webkit-scrollbar-thumb { background: transparent; border-radius: 4px; }
    .nav-scroll-area:hover { scrollbar-color: rgba(128, 128, 128, 0.35) transparent; }
    .nav-scroll-area:hover::-webkit-scrollbar-thumb { background: rgba(128, 128, 128, 0.35); }
}

/* Wrapper do Grupo 1 (modos de visualização). Fundo sutil apenas para
   delimitar o conjunto — os botões em si continuam com o estilo global de
   `.side-menu-nav .nav-item .nav-link` (48px, circular), que segue valendo por
   ser seletor descendente e sobreviver ao aninhamento. */
.nav-group {
    width: 100%;
}

.nav-group-inner {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 4px;
    padding: 6px 4px;
    margin: 4px 6px;
    list-style: none;
    border-radius: 18px;
    /* Token por marca E por tema (branding.css). Era `#34272e` fixo aqui, um
       marrom-vinho do Whiz, e ele aparecia atrás dos ícones também na ProsaZap
       e na Whiz Farma — a caixa ficava rosada no meio de uma lateral verde. */
    background: var(--brand-nav-group-bg, #34272e);
}

.nav-group-inner :deep(.nav-item) {
    list-style: none;
}

.user-dropdown {
    background: var(--bs-accordion-bg); 
    width: 280px;
    max-height: 500px;
    overflow-y: auto;
    border-radius: 12px;
    box-shadow: 0 5px 15px rgba(0,0,0,0.15);
}

.accordion-button {
    background-color: transparent;
    box-shadow: none;
    padding-left: 0.75rem;
    padding-right: 0.75rem;
}

.accordion-button:not(.collapsed) {
    color: var(--bs-primary);
    background-color: rgba(var(--bs-primary-rgb), 0.05);
}

.accordion-button::after {
    background-size: 0.8rem;
    opacity: 0.5;
}

/*
 * Configurar Agente — item de ação em destaque.
 *
 * Irmão de `.wa-connect-item`: mesma anatomia (cartão arredondado, ícone à
 * esquerda, seta à direita, elevação no hover), trocando o verde do WhatsApp
 * pela cor da marca. Fica no bloco de ações diretas, acima do accordion, porque
 * não é um grupo — é um destino.
 */
.agente-ia-item {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 10px;
    border-radius: 12px;
    border: 1px solid rgba(var(--bs-primary-rgb), 0.22);
    background: rgba(var(--bs-primary-rgb), 0.07);
    text-align: left;
    transition: background 0.18s ease, border-color 0.18s ease, transform 0.12s ease;
}

.agente-ia-item:hover {
    background: rgba(var(--bs-primary-rgb), 0.12);
    border-color: rgba(var(--bs-primary-rgb), 0.42);
    transform: translateY(-1px);
}

/* Sem o "pulo" no clique: o botão precisa parecer que afunda, não que escapa. */
.agente-ia-item:active {
    transform: none;
    background: rgba(var(--bs-primary-rgb), 0.16);
}

.agente-ia-item:focus-visible {
    outline: none;
    box-shadow: 0 0 0 3px rgba(var(--bs-primary-rgb), 0.28);
}

.agente-ia-icone {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    width: 34px;
    height: 34px;
    border-radius: 10px;
    font-size: 17px;
    color: #fff;
    background: linear-gradient(135deg, var(--bs-primary) 0%, color-mix(in srgb, var(--bs-primary) 82%, black) 100%);
}

.agente-ia-texto {
    display: flex;
    flex-direction: column;
    min-width: 0;
    line-height: 1.3;
}

.agente-ia-titulo {
    font-size: 13px;
    font-weight: 700;
    color: var(--bs-primary);
}

.agente-ia-sub {
    font-size: 11px;
    color: var(--bs-secondary-color);
}

.agente-ia-seta {
    margin-left: auto;
    font-size: 18px;
    line-height: 1;
    color: var(--bs-primary);
    opacity: 0.55;
    transition: opacity 0.18s ease, transform 0.18s ease;
}

.agente-ia-item:hover .agente-ia-seta {
    opacity: 1;
    transform: translateX(2px);
}

@media (prefers-reduced-motion: reduce) {
    .agente-ia-item,
    .agente-ia-seta {
        transition: none;
    }
    .agente-ia-item:hover {
        transform: none;
    }
    .agente-ia-item:hover .agente-ia-seta {
        transform: none;
    }
}

.dropdown-item {
    transition: all 0.2s ease;
    border-radius: 12px !important;
}

.dropdown-item:hover {
    background-color: var(--bs-sidebar-sub-bg);
    transform: translateX(4px);
}

.dropdown-item:active {
    background-color: rgba(var(--bs-primary-rgb), 0.07);
    color: inherit;
}

/* Custom Scrollbar Vertical */
.custom-scrollbar::-webkit-scrollbar {
    width: 0px;
}
.custom-scrollbar::-webkit-scrollbar-thumb {
    background-color: var(--bs-light);
    border-radius: 10px;
}

@media (max-width: 991px) {
    /* CORREÇÃO DO LAYOUT MOBILE */
    .side-menu-nav.resp-alinhar-menu {
        flex-wrap: nowrap !important;
        overflow-x: auto !important;
        justify-content: flex-start !important; /* Começa da esquerda para permitir scroll */
        padding-right: 1rem;
        gap: 6px; 
        -webkit-overflow-scrolling: touch; 
        scrollbar-width: none; 
        -ms-overflow-style: none;
    }
    
    .side-menu-nav.resp-alinhar-menu::-webkit-scrollbar { 
        display: none; 
    }

    /* Remove os estilos da pílula branca no mobile para não ocupar espaço extra e alinhar corretamente */
    .mobile-reset-ul {
        display: contents !important; /* Faz os filhos (li) se comportarem como parte do flex principal */
        margin: 0 !important;
        padding: 0 !important;
        background: transparent !important;
        box-shadow: none !important;
        border-radius: 0 !important;
    }
    
    /* Remove a borda inferior do item Kanban no mobile */
    .mobile-remove-border {
        border-bottom: none !important;
        padding-bottom: 0 !important;
    }

    /* Garante que os botões não encolham no scroll */
    .side-menu-nav .nav-item, 
    .side-menu-nav li {
        flex-shrink: 0;
    }
}


.notification-dropdown {
    width: 330px;
    background: var(--bs-white);
    border-radius: 1rem;
    box-shadow: 0 16px 48px rgba(0, 0, 0, 0.12);
    display: flex;
    flex-direction: column;
    margin-bottom: 1rem;
    
    /* Regras cruciais para a seta funcionar: */
    position: relative !important; 
    overflow: visible !important; 
}

[data-bs-theme="dark"] .notification-dropdown {
    box-shadow: 0 16px 48px rgba(0, 0, 0, 0.5);
}

/* --- A SETA (NOVO) --- */
.notification-dropdown::before {
    content: "";
    position: absolute;
    top: 24px; /* Alinha com a altura do ícone do sino */
    left: -12px; /* Joga a seta exatamente para o lado de fora */
    width: 0;
    height: 0;
    border-top: 10px solid transparent;
    border-bottom: 10px solid transparent;
    border-right: 12px solid var(--bs-body-bg); /* Puxa a mesma cor de fundo do Header */
    display: block;
    z-index: 9999; /* Garante que ela fique por cima de tudo */
}

[data-bs-theme="dark"] .notification-dropdown::before {
    border-right-color: var(--bs-body-bg);
}

/* --- HEADER --- */
.dropdown-header-custom {
    padding: 20px 20px 16px 20px;
    background: var(--bs-body-bg);
    border-top-left-radius: 1rem; /* <-- NOVO: Mantém o canto arredondado original */
    border-top-right-radius: 1rem; /* <-- NOVO: Mantém o canto arredondado original */
}

.dropdown-header-custom h6 {
    color: var(--bs-heading-color);
    letter-spacing: -0.3px;
}

.btn-mark-read { transition: opacity 0.2s; }
.btn-mark-read:hover { opacity: 0.8; text-decoration: underline !important; }

/* --- BODY (Card-in-Card Layout) --- */
.notification-body {
    max-height: 420px;
    overflow-y: auto;
    padding: 0 12px 12px 12px;
    background: var(--bs-body-bg); 
}

/* --- ITEMS (Notificações Flutuantes) --- */
.notification-item {
    background: var(--bs-tertiary-bg);
    border: 1px solid transparent;
    border-radius: 12px;
    padding: 16px;
    margin-bottom: 8px;
    transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
}

.notification-item:last-child { margin-bottom: 0; }

.notification-item:hover {
    transform: translateY(2px);
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.06);
    border-color: var(--bs-primary-rgb);
    background: var(--bs-body-bg);
}

[data-bs-theme="dark"] .notification-item { background: rgba(255, 255, 255, 0.03); }
[data-bs-theme="dark"] .notification-item:hover { 
    background: var(--bs-secondary-bg); 
    box-shadow: 0 8px 24px rgba(0,0,0,0.2);
}

/* --- ESTADO NÃO LIDO --- */
.notification-item.is-unread {
    background: var(--bs-primary-bg-subtle);
}

[data-bs-theme="dark"] .notification-item.is-unread {
    background: rgba(var(--bs-primary-rgb), 0.08);
}

/* Barra lateral indicando "Não Lido" */
.unread-indicator {
    position: absolute;
    top: 50%;
    left: 0;
    transform: translateY(-50%);
    width: 4px;
    height: 32px;
    background-color: var(--bs-primary);
    border-radius: 0 4px 4px 0;
}

/* --- ÍCONES --- */
.notif-icon-wrapper { width: 42px; height: 42px; font-size: 20px; }
.notif-icon-wrapper.icon-system { background-color: rgba(var(--bs-info-rgb), 0.12); color: var(--bs-info); }
.notif-icon-wrapper.icon-warning { background-color: rgba(var(--bs-warning-rgb), 0.15); color: var(--bs-warning); }
.notif-icon-wrapper.icon-success { background-color: rgba(var(--bs-success-rgb), 0.12); color: var(--bs-success); }

/* --- TEXTOS --- */
.notif-title { color: var(--bs-heading-color); max-width: 190px; }
.notif-message { word-break: break-word; }

/* --- FOOTER --- */
.dropdown-footer-custom {
    background: var(--bs-body-bg);
    padding: 12px 16px 16px 16px;
    border-top: 1px solid transparent;
    border-bottom-left-radius: 1rem; /* <-- NOVO: Mantém o canto arredondado original */
    border-bottom-right-radius: 1rem; /* <-- NOVO: Mantém o canto arredondado original */
}

.btn-footer {
    color: var(--bs-heading-color);
    background: var(--bs-tertiary-bg);
    border-radius: 10px;
    border: 1px solid transparent;
}

.btn-footer:hover {
    background: var(--bs-primary-rgb);
    color: var(--bs-primary);
    border-color: var(--bs-border-color-translucent);
}

.btn-footer:hover i { transform: translateX(4px); }

.icon-ATENDIMENTO_TRANSFERIDO {
    background-color: #e8f4fd;
    color: #2196f3; /* azul — transferência/movimentação */
}
.icon-ATENDIMENTO_FINALIZADO {
    background-color: #e8f8f0;
    color: #4caf50; /* verde — conclusão */
}
.icon-SINCRONIZACAO_CONTATOS_CONCLUIDA {
    background-color: #f3e8fd;
    color: #9c27b0; /* roxo — sincronização/sistema */
}
.icon-IMPORTACAO_CONTATOS_CONCLUIDA {
    background-color: #fff8e1;
    color: #ff9800; /* laranja — importação/upload */
}
.icon-EXPORTACAO_CONVERSAS_CONCLUIDA {
    background-color: #e0f2f1;
    color: #009688; /* verde-azulado — exportação pronta */
}
.icon-EXPORTACAO_CONVERSAS_ERRO {
    background-color: #fdecea;
    color: #e53935; /* vermelho — falha */
}

/* Ícone Empty State no Dark Mode */
[data-bs-theme="dark"] .icon-empty-state { background-color: var(--bs-secondary-bg) !important; }

@media (min-width: 992px) {
    .side-menu {
        min-height: 0 !important; /* overrides global min-height: 570px so sidebar never exceeds 100vh and gets clipped by layout-wrapper overflow:hidden */
        overflow-y: visible;
        overflow-x: visible;
        scrollbar-width: none; /* Firefox */
    }

    .side-menu::-webkit-scrollbar {
        display: none; /* Chrome / Safari */
    }

    /* flex-shrink: 0 prevents children from being compressed by flex algorithm.
       Without this, flex compresses items internally instead of letting the
       container overflow, so overflow-y: auto never triggers a scrollbar. */
    .side-menu > div {
        flex-shrink: 0;
    }
}

@media (max-width: 991.98px) {
    /* Fixa o menu na parte inferior da tela (estilo App) */
    .side-menu {
        position: fixed;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 65px;
        flex-direction: row !important;
        background-color: var(--bs-sidebar-bg, #ffffff);
        box-shadow: 0 -4px 20px rgba(0, 0, 0, 0.08);
        border-top: 1px solid var(--bs-border-color);
        display: flex !important;
        align-items: center;
        justify-content: space-between;
        padding: 0 10px;
    }

    /* Oculta o Logo no mobile (que estava poluindo o layout) */
    .navbar-brand-box {
        display: none !important;
    }

    /* Transforma a lista vertical em horizontal */
    .side-menu .nav.flex-column {
        flex-direction: row !important;
        flex: 1;
        justify-content: space-evenly;
        align-items: center;
        margin-bottom: 0 !important;
        height: 100%;
    }

    .side-menu .nav-item {
        margin: 0 !important;
    }

    /* Estiliza os botões para toque fácil (Touch Targets) */
    .side-menu .nav-link {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 48px;
        height: 48px;
        border-radius: 12px;
        padding: 0;
        transition: background-color 0.2s;
    }

    .side-menu .nav-link i {
        font-size: 24px !important;
    }

    /* Ajusta o Dropdown de Perfil/Configurações para ficar no canto direito */
    .profile-user-dropdown {
        margin-bottom: 0 !important;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .profile-user-dropdown .dropdown-toggle {
        width: 48px;
        height: 48px;
        margin: 0;
        padding: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        background: transparent;
    }

    .profile-user-dropdown .profile-user {
        width: 32px;
        height: 32px;
        border-radius: 50%;
        object-fit: cover;
    }

    /* Garante que o menu do perfil abra para CIMA, para não estourar a tela */
    .profile-user-dropdown .dropdown-menu {
        bottom: 75px !important;
        top: auto !important;
        left: auto !important;
        right: 10px !important;
        transform: none !important;
        box-shadow: 0 10px 30px rgba(0,0,0,0.2);
    }

    .order-mob-1 { order: 1 !important; }
    .order-mob-2 { order: 2 !important; }
    .order-mob-3 { order: 3 !important; }
    .order-mob-4 { order: 4 !important; }
    .order-mob-5 { order: 5 !important; }
    .order-mob-6 { order: 6 !important; }
    .order-mob-7 { order: 7 !important; }

    .home-mob{
        background: var(--bs-light);
        border-radius: 50%;
        box-shadow: var(--bs-shadow-sm);
    }
}
</style>